import React, { useState } from "react";
import { ChevronDown, ChevronRight, FileText } from "lucide-react";
import { DownloadLink } from "../common/DownloadLink";

export interface DocEvidencePayload {
  doc?: string;
  section?: string;
  excerpt?: string;
}

export interface DocEvidenceProps {
  ev: DocEvidencePayload;
}

/* Inline document-evidence accordion shown inside an Approvals card when a
   check produced a doc-attached finding. */
export function DocEvidence({ ev }: DocEvidenceProps): JSX.Element {
  const [open, setOpen] = useState<boolean>(false);
  const [full, setFull] = useState<boolean>(false);
  return (
    <div
      style={{
        margin: "6px 0 8px",
        border: "1px solid var(--bd)",
        borderRadius: 5,
        background: "var(--subtle)",
      }}
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "6px 9px",
          cursor: "pointer",
          fontSize: 11.5,
          color: "var(--muted)",
        }}
      >
        {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
        <FileText size={11} />
        <span style={{ fontWeight: 500, color: "var(--fg)" }}>Document evidence</span>
        <span className="mono" style={{ fontSize: 11 }}>
          · {ev.doc}
          {ev.section ? " · " + ev.section : ""}
        </span>
        {ev.doc && (
          <span style={{ marginLeft: "auto" }}>
            <DownloadLink doc={{ filename: ev.doc }} size={11} variant="sm" />
          </span>
        )}
      </div>
      {open && (
        <div
          style={{
            padding: "8px 11px",
            fontFamily: "var(--mono)",
            fontSize: 11,
            lineHeight: 1.55,
            whiteSpace: "pre-wrap",
            background: "#fbfbfb",
            borderTop: "1px solid var(--bd)",
            maxHeight: full ? 500 : 140,
            overflowY: "auto",
          }}
        >
          {ev.excerpt}
          {!full && ev.excerpt && ev.excerpt.length > 320 && "…"}
        </div>
      )}
      {open && (
        <div style={{ padding: "5px 11px 7px", fontSize: 11 }}>
          <button className="lnk" onClick={() => setFull(!full)}>
            {full ? "Collapse" : "View full document"}
          </button>
        </div>
      )}
    </div>
  );
}
